// eslint-disable-next-line import-x/order
import { type Theme } from './augmented-theme.js'

import { type SxProps, IconButton } from '@mui/material'
import { useTheme as useMuiTheme, createTheme } from '@mui/material/styles'

// reason: not cleaned up yet :(
// eslint-disable-next-line @dhl/generic/no-restricted-imports
import { createMakeAndWithStyles, type CSSObject } from 'tss-react'

/**
 * @deprecated please use sx props or styled components to create CSS
 */
const tss: ReturnType<typeof createMakeAndWithStyles<Theme>> = createMakeAndWithStyles<Theme>({
  useTheme: () => useMuiTheme(),
  // officially the tss setup also had a cache option, we never used it and we are moving away from it
  // so i leave it like this
})

type Sx = SxProps<Theme>

export { tss, IconButton, createTheme, type Theme, type CSSObject, type Sx }

// lots of apps just kept their sx object and then pick stuff, these get package esm non esm error :)
export {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Backdrop,
  Badge,
  Box,
  Button,
  Chip,
  CircularProgress,
  Collapse,
  Container,
  Dialog,
  Divider,
  FormControlLabel,
  FormGroup,
  Grid,
  InputAdornment,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Modal,
  Paper,
  Radio,
  Stack,
  SvgIcon,
  SwipeableDrawer,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
  styled,
  type BoxProps,
  type ButtonProps,
  type Components,
  type DialogProps,
  type Palette,
  type PaletteMode,
  type SvgIconProps,
  type SxProps,
  type TextFieldProps,
} from '@mui/material'

export { breakpoints } from './breakpoints.js'
export { ThemeProvider, type ThemeOrFunc } from './ThemeProvider.js'
export { CacheProvider } from './CacheProvider.js'
export { useColorScheme } from './use-color-scheme.js'

export type { PreferredColorScheme } from './colorSchemeContext.js'
export type { ThemeDeviceProps } from './device-props.js'

// only exported for connector
export { rawThemeCurrent } from './theme.js'
export { useDeviceDetect } from './device.js'
export { createPalette } from './palette.js'
